import auth0 from 'auth0-js';

export default class Auth {
    constructor(history) {

        this.history = history;
        this.userProfile = null;

        this.requestedScopes = "openid profile email read:clients";

        this.auth0 = new auth0.WebAuth({
            domain: process.env.REACT_APP_AUTH0_DOMAIN,
            clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
            redirectUri: process.env.REACT_APP_AUTH0_CALLBACK_URL,
            audience: process.env.REACT_APP_AUTH0_AUDIENCE,
            responseType: "token id_token",
            scope: this.requestedScopes
        });
    }

    login = () => {
        this.auth0.authorize();
    }

    handleAuthentication = () => {
        this.auth0.parseHash((err, authResult) => {            
            if (authResult && authResult.idToken
                && authResult.accessToken
                && authResult.idTokenPayload['https://localhost:44382.com/agencykey'][0]) {

                this.setSession(authResult);
                this.history.push("/cases");
            }
            else {
                this.history.push("/");
            }
        });
    }

    setSession = authResult => {
        
        //set time access token will expire
        const expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());

        const scopes = authResult.scope || this.requestedScopes || "";

        localStorage.setItem("access_token", authResult.accessToken);
        localStorage.setItem("id_token", authResult.idToken);
        localStorage.setItem("expires_at", expiresAt);
        localStorage.setItem("scopes", JSON.stringify(scopes));
        localStorage.setItem("agency_key", authResult.idTokenPayload['https://localhost:44382.com/agencykey'][0]);
    }

    isAuthenticated() {
        if (!localStorage.getItem("agency_key"))
            return false;

        const expiresAt = JSON.parse(localStorage.getItem("expires_at"));
        
        return new Date().getTime() < expiresAt;
    }

    logout = () => {

        this.clearLocalStorage();

        this.history.push("/");
    }

    logoutNoRedirect = () => {
        this.clearLocalStorage()
    }

    clearLocalStorage() {
        localStorage.removeItem("access_token");
        localStorage.removeItem("id_token");
        localStorage.removeItem("expires_at");
        localStorage.removeItem("agency_key");
        localStorage.removeItem("scopes");
        this.userProfile = null;

        this.auth0.logout(
            {
                clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
                returnTo: process.env.REACT_APP_HOME
            });
    }

    userHasScopes(scopes) {
        const grantedScopes = (
            JSON.parse(localStorage.getItem("scopes")) || ""
        ).split(" ");

        return scopes.every(scope => grantedScopes.includes(scope));
    }

    getAccessToken = () => {
        const accessToken = localStorage.getItem("access_token");        
        return accessToken;
    }

    getProfile = cb => {
        if (this.userProfile) return cb(this.userProfile);

        this.auth0.client.userInfo(this.getAccessToken(), (err, profile) => {
            if (profile) this.userProfile = profile;
            cb(profile, err);
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/Auth/Auth.js